export enum ETarget {
  PRESCRIPTION = 'prescricao'
}
